import { render, staticRenderFns } from "./LinkFacebook.vue?vue&type=template&id=561c0994&scoped=true&"
import script from "./LinkFacebook.vue?vue&type=script&lang=js&"
export * from "./LinkFacebook.vue?vue&type=script&lang=js&"
import style0 from "./LinkFacebook.vue?vue&type=style&index=0&id=561c0994&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561c0994",
  null
  
)

export default component.exports